import React, {useEffect, useRef, useState} from "react";
import {useBillingContext} from "..";
import GeneralSettingsForm from "./generalSettingsForm";
import CertificateForm from "./certificateForm";
import SubmitButton from "./submitButton";
import APIService from "../../../modules/apiService";


export default function CreateCert() {
  const forceTimeout = 3; // en minutos
  const api = new APIService();
  const {showErrorModal, fetchBillingSettings} = useBillingContext();
  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [showWaitingAlert, setShowWaitingAlert] = useState(false);
  const pollingInterval = useRef(null);

  const [form, setForm] = useState({
    cuit: "",
    clave: "",
    company_name: "",
    fantasy_name: "",
    fiscal_position: "6",
    iibb: "",
    business_address: "",
    activity_start_date: "",
  });

  const handleFormChange = (e) => {
    const newForm = {...form, [e.target.name]: e.target.value};
    setForm(newForm);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSaving(true);
    setErrors({});
    setShowWaitingAlert(false);

    const startPollingStatus = () => {
      pollingInterval.current = setInterval(async () => {
        try {
          const response = await api.getMyBillingSettings();

          if (response.ok) {
            const {data} = await response.json();
            if (data) {
              clearInterval(pollingInterval.current);
              pollingInterval.current = null;
              setShowWaitingAlert(false);
              fetchBillingSettings();
            }
          }
        } catch (err) {
          console.error(err);
          showErrorModal(`Error al obtener la configuración de facturación: ${err.message}`);
        }
      }, ((forceTimeout * 60 * 1000) / 20));
    };

    try {
      const response = await api.postBillingSettings(form);
      const data = await response.json();

      if (response.ok) {
        setShowWaitingAlert(true);
        startPollingStatus();
      } else if (response.status === 422) {
        setErrors(data?.errors ?? {});
      } else {
        throw new Error(data?.message);
      }
    } catch (err) {
      showErrorModal(err.message);
      // startPollingStatus();
    }

    setIsSaving(false);
  };

  useEffect(() => {
    return () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current);
      }
    };
  }, []);

  return (
    <>
      <h2>Generación de certificados</h2>
      <p className="mb-5 mt-1">Para poder emitir facturas, es necesario generar los certificados digitales que nos
        comunican con ARCA (AFIP).</p>
      <form onSubmit={handleSubmit} autoComplete="off">
        <GeneralSettingsForm
          formData={form}
          errors={errors}
          handleChange={handleFormChange}
          disabled={isSaving || showWaitingAlert}
        />
        <CertificateForm
          formData={form}
          errors={errors}
          handleChange={handleFormChange}
          disabled={isSaving || showWaitingAlert}
        />
        <SubmitButton
          isSubmitting={isSaving || showWaitingAlert}
          submittingText="Generando..."
          text="Generar certificado"
        />
        {showWaitingAlert && (
          <div className="alert alert-warning mt-3">
            La generación del certificado puede tardar hasta {forceTimeout} minutos por motivos ajenos a Medicloud
            (👉 ARCA/AFIP). Sea paciente por favor, y no cierre esta ventana 🙏.
          </div>
        )}
      </form>
    </>
  );
}
